/**
 * @type {string}
 * @description Custom attribute for setting the flex grow of a component.
 */
export const CUSTOM_FLEX_GROW_ATTRIBUTE = 'custom-flex-grow';

/**
 * @type {string}
 * @description Custom attribute for setting the image of the details view.
 */
export const DETAILS_VIEW_ATTRIBUTE_IMG = 'image';

/**
 * @type {string}
 * @description Custom attribute for setting the active id.
 */
export const ACTIVE_ID_ATTRIBUTE = 'active-id';

/**
 * @type {string}
 * @description Custom attribute for setting the options.
 */
export const OPTIONS_ATTRIBUTE = 'options';

/**
 * @type {string}
 * @description Custom attribute for setting add cart method type.
 */
export const ADD_COLLECTION_METHOD_TYPE_ATTRIBUTE = 'add-collection-method-type';

/**
 * @type {string}
 * @description Custom attribute for setting the current item id.
 */
export const CURRENT_ITEM_ID_ATTRIBUTE = 'current-item-id';

/**
 * @type {string}
 * @description Custom attribute for setting the item name.
 */
export const ITEM_NAME_ATTRIBUTE = 'item-name';

/**
 * @type {string}
 * @description Custom attribute for setting the current item type.
 */
export const CURRENT_WESOG_PROVIDER_ATTRIBUTE = 'current-wesog-provider';

/**
 * @type {string}
 * @description Custom attribute for setting the title.
 */
export const TITLE_ATTRIBUTE = 'title';

/**
 * @type {string}
 * @description Custom attribute for setting the type.
 */
export const TYPE_ATTRIBUTE = 'type';

/**
 * @type {string}
 * @description Custom attribute for setting the keyword.
 */
export const KEYWORD_ATTRIBUTE = 'keyword';

/**
 * @type {string}
 * @description Custom attribute for setting the data id.
 */
export const DATA_ID_ATTRIBUTE = 'data-id';

/**
 * @type {string}
 * @description Custom attribute for empty results component.
 */
export const EMPTY_RESULTS_ATTRIBUTE = 'data-empty-results';

/**
 * @type {string}
 * @description Custom attribute for setting the min img height.
 */
export const MIN_IMG_HEIGHT_ATTRIBUTE = 'min-img-height';

/**
 * @type {string}
 * @description Custom attribute for setting the mode view.
 */
export const MODE_VIEW_ATTRIBUTE = 'mode-view';

/**
 * @type {string}
 * @description Custom attribute for setting the reports view.
 */
export const REPORTS_VIEW_ATTRIBUTE = 'reports-view';

/**
 * @type {string}
 * @description Custom attribute for setting the details view.
 */
export const DETAILS_VIEW_ATTRIBUTE = 'details-view';

/**
 * @type {string}
 * @description Custom attribute for setting the report details view.
 */
export const REPORT_DETAILS_VIEW_ATTRIBUTE = 'report-details-view';

/**
 * @type {string}
 * @description Custom attribute for setting the data translate.
 */
export const DATA_TRANSLATE_ATTRIBUTE = 'data-translate';

/**
 * @type {string}
 * @description Custom attribute for setting the zoom in.
 */
export const ZOOM_IN_ATTRIBUTE = 'zoom-in';
